
import { defineComponent, ref } from 'vue'
import { useStore } from '@/store/index'
import SearchHistoryContent from '@/components/SearchHistoryContent.vue'

export default defineComponent({
  components: { SearchHistoryContent },
  setup() {
    const store = useStore()
    const dimmer = ref(true)

    return {
      store,
      dimmer
    }
  },
})
